import { create } from "zustand";

import checkUser from "../utils/checkUser";
import { signOutApi } from "../apis/index";
import { formatUserInfo } from "../adapter/formatUserData";
import { expireFn } from "../utils/tools";

const authStore: any = create((set: any, get: any) => ({
  userLoading: true,
  // authInfo: {},
  appInfo: {
    mount: false,
  },
  userInfo: formatUserInfo(window.currentUser),
  /**
   * 更新app状态
   * @param
   */
  updateAppInfo: (f: string, v: boolean) => {
    set(() => ({
      ...get().appInfo,
      [f]: v,
    }));
  },
  /**
   * 强制更新
   */
  updateUserInfo: async () => {
    await get().getUserInfo(true);
  },
  /**
   * 是否强制拉取用户信息
   * @param force
   */
  getUserInfo: async (force?: boolean) => {
    set(() => ({
      userLoading: true,
    }));
    const res = await checkUser(force);
    set(() => ({
      // authInfo: res.auth,
      userInfo: res.user,
      userLoading: false,
    }));
  },
  /**
   * 退出登录
   */
  logout: async () => {
    await signOutApi();
    expireFn();
    location.reload();
  },
  changeUserInfoLocal: (key: string, value: any) => {
    set(() => ({
      userInfo: {
        ...get().userInfo,
        [key]: value,
      },
    }));
  },
}));

export default authStore;
